export default __webpack_public_path__ + "static/media/Frame12.08c9d76e.jpg";